"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AbsenceTypeEditModalButton = AbsenceTypeEditModalButton;
exports.AbsenceTypeAddNewModalButton = AbsenceTypeAddNewModalButton;
const react_1 = __importDefault(require("react"));
const GeneralModalButtons_1 = require("../../../View/Modals/GeneralModalButtons");
const AbsenceTypesController_1 = require("../AbsenceTypesController");
const AbsenceTypeModalBody_1 = require("./AbsenceTypeModalBody");
const AbsenceTypeValidationSchema_1 = require("./AbsenceTypeValidationSchema");
function AbsenceTypeEditModalButton({ modalProps: { onEdit, initialData }, }) {
    return (react_1.default.createElement(GeneralModalButtons_1.GeneralEditModalButton, { modalProps: {
            onEdit: onEdit,
            ModalBodyComponent: AbsenceTypeModalBody_1.AbsenceTypeModalBody,
            modalTitle: "Edycja typu nieobecności",
            repository: AbsenceTypesController_1.absenceTypesRepository,
            initialData: initialData,
            makeValidationSchema: AbsenceTypeValidationSchema_1.makeAbsenceTypeValidationSchema,
        }, buttonProps: {
            buttonVariant: "outline-success",
        } }));
}
function AbsenceTypeAddNewModalButton({ modalProps: { onAddNew }, }) {
    return (react_1.default.createElement(GeneralModalButtons_1.GeneralAddNewModalButton, { modalProps: {
            onAddNew: onAddNew,
            ModalBodyComponent: AbsenceTypeModalBody_1.AbsenceTypeModalBody,
            modalTitle: "Dodaj typ nieobecności",
            repository: AbsenceTypesController_1.absenceTypesRepository,
            makeValidationSchema: AbsenceTypeValidationSchema_1.makeAbsenceTypeValidationSchema,
        }, buttonProps: {
            buttonCaption: "Dodaj typ",
            buttonVariant: "outline-success",
        } }));
}
